import * as DOMPurify from 'dompurify';

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName === 'iframe') {
    let src = node.getAttribute('src') || '';

    // Remove localhost or 127.0.0.1 prefixes that may have been added
    src = src.replace(/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/+/gi, '');

    // Update the src attribute with cleaned URL
    if (src !== node.getAttribute('src')) {
      node.setAttribute('src', src);
    }

    if (
      !(
        src.startsWith('https://www.canva.com/design/') ||
        /cloudfront.net\/index\.php\/posterbuilder\/view\/(.*)$/.test(src)
      )
    ) {
      return node.parentNode?.removeChild(node);
    }
  }
});

export default DOMPurify;
